'use client';

import { Swiper, SwiperSlide } from 'swiper/react';
import { useState, useEffect } from 'react';
import type { CompanyResource } from '../api';
import { getImageURL } from '@/utils/helper';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';

export const useDebouncedWindowSize = (delay = 100) => {
  const [windowSize, setWindowSize] = useState({ width: 375, height: 210 });

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    let timeoutId: NodeJS.Timeout;
    const handleResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      }, delay);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(timeoutId);
    };
  }, [delay]);

  return windowSize;
};

export default function Index({ data }: { data?: CompanyResource[]}) {
  const { width } = useDebouncedWindowSize();
  const items = data?.map((item) => {
    return (
      <SwiperSlide key={item.id}>
        <video controls preload="metadata" loop={false} muted autoPlay poster="" style={{width: width - 30, height: (width-30) * 9 / 16}}>
          <source src={getImageURL(item.url)} type="video/mp4" />
          您的浏览器不支持视频播放。
        </video>
      </SwiperSlide>
    );
  });

  if (!data?.length) {
    return null;
  }
  
  return (
    <div className="mb-[20px]">
      <Swiper modules={[Pagination]} loop pagination={{ clickable: true }}>
        {items}
      </Swiper>
    </div>
  );
}
